import React from 'react';

export class Loader extends React.Component {
  render() {
    return (
      <div className="d-flex" style={{ height: "100vh", background: "#f2f4f8" }}>
        <div style={{ maxWidth: "100%", margin: "auto", textAlign: "center" }}>
          <svg height='100' width='100'>
            <image
              x='0'
              y='0'
              height='100'
              width='100'
              xlinkHref='/assets/loading.svg'
            />
          </svg>

          <h4>Loading...</h4>
        </div>
      </div>
    )
  }
};
